import React, { useState } from "react";
import styles from "../Reports/report.module.css";
import SlideBox from "../../common/SlideBox/SlideBox";
import { useSelector } from "react-redux";
import { OnBoardingRegistry } from "../../Privillages/OnBoardingRegistry";

const OnBoardingView = () => {
  const [flag, setFlag] = useState(false);
  const [report, setReport] = useState("");
  const { catalog = {}, allowed = [] } = useSelector((state) => state.userPrivileges);
  const userPrivilegeIdSet = new Set(allowed);

  const toggleRightBar = (type) => {
    if (type) {
      setReport(type);
    }
    setFlag(!flag);
  };

  const onToggle = (key) => {
    setReport(key);
    setFlag((v) => !v);
  };

  const onboardConfig = catalog?.Onboarding || {};
  const selectedonboard = OnBoardingRegistry.find((t) => t?.key === report);
  return (
    <div className="content-body">
      <div className="container-fluid ">
        <div className="card card-inverse card-primary text-center">
          <div className="card-body pb-1">
            <SlideBox flag={flag} toggleRightBar={onToggle}>
              {selectedonboard?.component &&
                React.createElement(selectedonboard.component, {
                  type1: report,
                  toggleRightBar: onToggle,
                })}
            </SlideBox>
            <div className="row text-center text-lg-start">
              <div className="row text-center text-lg-start">
                {(() => {
                  return OnBoardingRegistry.map((item, idx) => {
                    const requiredSubs = Array.isArray(item.requiredSub)
                      ? item?.requiredSub
                      : [item?.requiredSub];

                    const hasAccess = requiredSubs.some((subKey) => {
                      const subId = onboardConfig?.idMap?.[subKey];
                      return subId && userPrivilegeIdSet.has(subId);
                    });

                    if (!hasAccess) return null;

                    return (
                      <div
                        key={item.key || idx}
                        className={`col-lg-3 col-md-3 col-4 mb-5 ${styles["report-icon"]}`}
                      >
                        <div
                          className="d-flex flex-column justify-content-center align-items-center"
                          onClick={() => toggleRightBar(item.key)}
                        >
                          <img
                            className="img-fluid img-thumbnail mb-2"
                            src={item.icon || "/images/default-icon.png"}
                            alt={item.title}
                            width="60"
                            height="60"
                            style={{ objectFit: "contain" }}
                          />
                          <h5 className="mt-2 text-primary text-md text-sm">
                            {item.label || "NA"}
                          </h5>
                        </div>
                      </div>
                    );
                  });
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnBoardingView;